import getters from "@/store/modules/about/getters";
export default {
    namespaced: true,
    state() {
        return {
            aboutMe: "Currently working at Storeino as a Full-Stack developer intern while preparing my engineering degree in computer science at ENSA Agadir.I'm quitely confident, naturally curious and perpetually working on improving my chops one problem at a time. I discovered web development in an early age and I realized it would be the perfect fit because I've always been passionate with solving problems, bringing ideas into life and making the world a better place.I don't like to define myself by the work I've done, I define my self by the work I want to do.I'm a well-organized person, I dedicate most of my time to school and self-learning but I never neglect my personal life, because I believe that skills can be taught personality is inherent.",
            educations : [
                {
                    id: '1',
                    year: '2017',
                    heading: 'French Institute Agadir',
                    description: 'Diploma of French Language Studies B2 (DELF)'
                },
                {
                    id: '2',
                    year: '2017 - 2018',
                    heading: 'Al Qalam High School',
                    description: 'Moroccan Baccalaureat branch Mathematical Sciences B'
                },
                {
                    id: '3',
                    year: '2018 - 2020',
                    heading: 'National School Of Applied Sciences - Agadir',
                    description: 'College Preparatory'
                },
                {
                    id: '4',
                    year: 'From 2020',
                    heading: 'National School Of Applied Sciences - Agadir',
                    description: 'Computer Sciences Engineering Degree'
                }
            ],
            experiences: [
                {
                    id: '1',
                    year: '2018',
                    period: 'February to June',
                    function:'Contributor',
                    company: 'Non-Profit Organization ',
                    description: 'Fundraising through sponsorship and collecting clothing for autistic children.',
                },
                {
                    id: '2',
                    year: '2020',
                    period: 'September to January 2021'  ,
                    function:'Participant',
                    company: 'MCPC',
                    description: 'Won the bronze medal and qualified to the African and Arab Collegiate Programming Contest in Egypt to represent Morocco.',
                },
                {
                    id: '3',
                    year: '2021',
                    period: 'July to August',
                    function:'Backend Developer',
                    company: 'SL2P',
                    description: 'Created a wordpress theme adapted to the needs of the company.',
                },
                {
                    id: '4',
                    year: '2022',
                    period: 'From February',
                    function:'Full Stack Developer',
                    company: 'Storeino',
                    description: 'Creating a marketplace that brings together Storeino sellers and buyers.',
                }
            ]

        }
    },
    getters,
}